export default __webpack_public_path__ + "static/Instagram-96a32439b56c7ae4a9c0e44f814bc462ae4f11b8ea363fd64940e81ad18cc279.png";